import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M13 0v3l2.4-1.8 1.2 1.6L13 5.5v4.768l4.13-2.384.538-4.467 1.985.239-.359 2.978 2.599-1.5 1 1.732-2.599 1.5 2.76 1.179-.786 1.839-4.139-1.768L14.001 12l4.128 2.384 4.138-1.768.786 1.84-2.759 1.178 2.598 1.5-1 1.732-2.598-1.5.359 2.978-1.986.24-.538-4.468-4.13-2.384V18.5l3.6 2.7-1.2 1.6L13 21v3h-2v-3l-2.4 1.8-1.2-1.6 3.6-2.7v-4.768l-4.128 2.384-.538 4.468-1.986-.24.359-2.978-2.598 1.5-1-1.732 2.598-1.5-2.759-1.178.786-1.84 4.138 1.768L10.001 12 5.87 9.616l-4.139 1.767-.785-1.839 2.759-1.178-2.598-1.5 1-1.732 2.598 1.5-.36-2.979 1.986-.239.539 4.468L11 10.268V5.5L7.4 2.8l1.2-1.6L11 3V0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowNormalSmall;
